import { m } from '~/paraglide/messages.js';

const InvitationErrorPage = () => {
  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4">
      <div className="text-center mb-16">
        <h1 className="text-2xl md:text-3xl font-semibold text-white mb-4">
          {m['invite.error.title']()}
        </h1>
        <div className="w-full h-0.5 bg-gray-700 mx-auto" />
      </div>

      <div className="flex flex-col items-center justify-center mb-16">
        <div className="mb-8">
          <img
            src="/invite.svg"
            alt={m['invite.error.alt_text']()}
            className="w-64 h-64 md:w-80 md:h-80"
          />
        </div>
      </div>

      <div className="text-center">
        <p className="text-muted-foreground text-lg">
          {m['invite.error.message']()}
        </p>
      </div>
    </div>
  );
};

export { InvitationErrorPage };
